import React, { useCallback, useEffect, useState } from 'react'
import '../Affichage.css'
import { useCookies } from 'react-cookie'
import dayjs from 'dayjs'
import { Link, redirect, useNavigate } from 'react-router-dom'
import { Marketing } from '../../../../../Models/Marketing/MarketingModels'
import { MarketingService } from '../../../../../Services/Marketing/MarketingService'
import { URL_IMAGE, URL_MIDIS } from '../../../../../Setting'

export function Dashboard() {

  //services
  const[cookies] = useCookies(['token']);
  const token = cookies.token;

  const [marketing, setMarketing] = useState<Marketing>();
  let navigate = useNavigate();

  //Automatisation/récupération des données
  const chargementDonnees = useCallback(async ()=>{
    if(token){
        const marketsResult = await MarketingService().getComMidisMarketingEnCours(token);
        if(marketsResult.length>0 && marketsResult.find(market=>market.fichiers.length>0))setMarketing(marketsResult[0]);
        if(marketsResult.length===0)navigate('./horairesPermanents')
    }
  },[navigate, token]); 


  useEffect(()=>{
    chargementDonnees();
  },[chargementDonnees])


  return (
    <div className='affichageInfo' style={{display:'flex', justifyContent:'center', width:"100%"}}>
      {
        marketing && marketing.fichiers.length>0 &&
        <Link style={{textDecoration:'none'}} to={'.'+marketing.lien}>
          <img style={{width:'100%', height:'100%'}} src={URL_MIDIS+marketing.fichiers[0].chemin} alt='logo'/>
        </Link>
      }
    </div>
  )
}